import { render, staticRenderFns } from "./Q4sHero.vue?vue&type=template&id=e92e47e0&scoped=true"
import script from "./Q4sHero.vue?vue&type=script&lang=ts"
export * from "./Q4sHero.vue?vue&type=script&lang=ts"
import style0 from "./Q4sHero.vue?vue&type=style&index=0&id=e92e47e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92e47e0",
  null
  
)

export default component.exports